import React, { useEffect, useState, useImperativeHandle } from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import Dropdown from "../../elements/dropdown";
import { getStores } from "../../services/storeService";
import { connect } from "react-redux";
import { pickupStoreSelector } from "../../selectors/gears-checkout";
import { isEmptyObject } from "../../utils/siteUtils";

const StoreInformation = React.forwardRef((props, ref) => {
  const { headingType, heading, storeLabel, storeMissingMessage, isDisabled, onChange, pickupStore, visible } = props;
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [storeError, setStoreError] = useState(null);

  useImperativeHandle(ref, () => ({
    validateForm: validateForm
  }));
  useEffect(() => {
    init().then();
  }, []);
  useEffect(() => {
    if (stores && pickupStore) {
      const store = stores.find(e => e.code === pickupStore.code);
      setSelectedStore(store);
      onChange && onChange(store);
    }
  }, [stores, pickupStore]);
  const init = async () => {
    const stores = (await getStores()).map(({ storeCode, storeName, ...other }) => ({
      code: storeCode,
      value: storeName,
      ...other
    }));
    setStores(stores);
  };

  const validateForm = () => {
    let isValid = true;
    if (isEmptyObject(selectedStore)) {
      isValid = false;
      setStoreError(storeMissingMessage.value);
    }
    return { isValid, selectedStore };
  };
  const storeProps = {
    placeholder: storeLabel?.value,
    options: stores,
    selectedOption: selectedStore,
    showError: !!storeError,
    warningMessage: storeError,
    disabled: isDisabled,
    onFocus: evt => {
      setStoreError(null);
    },
    onChange: option => {
      setSelectedStore(option);
      onChange && onChange(option);
    }
  };
  if (visible) {
    return (
      <div className="store-information">
        <Heading className="store-information__heading" type={headingType} html={heading} />
        <Dropdown {...storeProps} />
      </div>
    );
  } else {
    return null;
  }
});
const mapStateToProps = state => ({
  pickupStore: pickupStoreSelector(state)
});
export default connect(mapStateToProps, null, null, { forwardRef: true })(StoreInformation);

StoreInformation.displayName = "StoreInformation";
// StoreInformation.propTypes = {
//   heading: PropTypes.string.isRequired
// };
StoreInformation.defaultProps = {};
